module.exports = __webpack_public_path__ + "static/img/m3m3i2.b111383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/m3m3i2.png
// module id = /LQA
// module chunks = 1